import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, CSP_NONCE, provideZonelessChangeDetection } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { translateModuleConfig } from './config/translate.config';

function getNonce(): string {
  if (typeof document !== 'undefined') {
    const appRoot = document.querySelector('app-root');
    return appRoot?.getAttribute('ngCspNonce') || '';
  }
  return '';
}

const nonce = getNonce();

const SmartReconTheme = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '#e3eef2',
          contrastColor: '#3b6d81',
          inverseColor: '#fff',
          hoverColor: '#3b6d81',
          selectedColor: '#c7dde6',
          activeColor: '#888',
          borderColor: '#68a2b9',
        },
        highlight: {
          background: '#e3eef2',
          focusBackground: '#3b6d81',
          color: '#3b6d81',
          focusColor: '#fff',
        },
      },
      dark: {
        primary: {
          color: '#292929',
          contrastColor: '#3a4048',
          inverseColor: '#fff',
          hoverColor: '#cedee5',
          selectedColor: '#444',
          activeColor: '#888',
          borderColor: '#ffffff80',
        },
        highlight: {
          background: '#333',
          focusBackground: '#555',
          color: '#fff',
          focusColor: '#fff',
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
    ),
    providePrimeNG({
      theme: {
        preset: SmartReconTheme,
      },
      csp: { nonce: nonce },
    }),
    provideHttpClient(withFetch()),
    ...translateModuleConfig(),
    {
      provide: CSP_NONCE,
      useValue: nonce,
    },
    provideClientHydration(withEventReplay()),
  ],
};
